import {
  FirstletterUpperCase,
  customPasswordCheck,
  equal,
  greaterThan,
  length,
  notEqual,
} from "./javascript";
import {
  firstLetterToUppercase,
  emailValidation,
  regularString,
  numberOnly,
} from "./regex";

const formValidation = (name, value, state, ignore = [], optional = []) => {
  const formErrors = { ...state?.formErrors };
  if (ignore.includes(name)) {
    if (formErrors[name]) formErrors[name] = "";
    return formErrors;
  }
  switch (name) {
    case "email":
      if (equal(length(value))) {
        formErrors[name] = `Email is required!`;
      } else if (!regularString(value)) {
        formErrors[name] = `Unnecessary space or special character in word!`;
      } else if (!emailValidation(value)) {
        formErrors[name] = `Email must be a valid email.`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "fullName":
    case "beforeImage":
    case "projectName":
    case "propertyType":
    case "subject":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (!regularString(value)) {
        formErrors[name] = `Unnecessary space or special character in word!`;
      } else if (greaterThan(length(value), 70)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 70 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "message":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (greaterThan(length(value), 300)) {
        formErrors[name] = `${firstLetterToUppercase(
          name
        )} exceeds character limit. Maximum allowed: 300 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "comment":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "url":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (!regularString(value)) {
        formErrors[name] = `Unnecessary space in url!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "loginPassword":
      if (equal(length(value))) {
        formErrors[name] = `Password is required!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "password":
    case "newPassword":
      if (equal(length(value))) {
        formErrors[name] = `${FirstletterUpperCase(name)} is required!`;
      } else if (customPasswordCheck(value).length) {
        formErrors[name] = customPasswordCheck(value);
      } else {
        formErrors[name] = "";
      }
      break;

    case "confirmPassword":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (notEqual(state.password, value)) {
        formErrors[name] = `Password and Confirm Password is not match!`;
      } else if (equal(state.password, value)) {
        formErrors[name] = "";
      }
      break;

    case "confirmNewPassword":
      if (equal(length(value))) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (notEqual(state.newPassword, value)) {
        formErrors[name] = `New Password and Confirm Password is not match!`;
      } else if (equal(state.newPassword, value)) {
        formErrors[name] = "";
      }
      break;
    case "otp":
      if (!value) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
      } else if (value.toString().length < 6 || value.toString().length > 6) {
        formErrors[name] = "OTP must be equal 6 digits!";
      } else {
        formErrors[name] = "";
      }
      break;
    case "images":
    case "items":
      if (!value || !value.length) {
        formErrors[name] = `Please upload some photos of your property!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "agreeToTermsAndConditions":
      if (!value) {
        formErrors[name] = `Please check ${firstLetterToUppercase(name)}!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "phoneNumber":
      if ((equal(length(value)) || value == null) && !optional.includes(name)) {
        formErrors[name] = `${firstLetterToUppercase(name)} is required.`;
      } else if (value && !numberOnly(value)) {
        formErrors[name] = `Unnecessary space or special character in word.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "serviceId":
      if (equal(length(value))) {
        formErrors[name] = `Service is required!`;
      } else {
        formErrors[name] = "";
      }
      break;
    default:
      break;
  }
  return formErrors;
};

export default formValidation;
